import {Injectable} from "@angular/core";
import {DxUserSession} from "../../../domain/user/dx-user-session";
import {Observable} from "rxjs";
import {DxSessionRefreshStrategy} from "./dx-session-refresh-strategy";
import {fromPromise} from "rxjs/internal-compatibility";
import {DxHttpDispatcher} from "../../../../dx-core/services/dx-http-dispatcher.service";
import {DxConfigService} from "../../../../dx-core/services/dx-config.service";
import {DxEncryptionService} from "../../../../dx-core/services/dx-encryption.service";
import {DxKeycloakAuthenticationStrategy} from "../auth/dx-keycloak-authentication-strategy";
import {HttpHeaders} from "@angular/common/http";
import {DxEncryptionStrategyType} from "../../../../dx-core/config/dx-encryptions-type";
import {DxKeycloakUtils} from "../../utils/dx-keycloak-utils";
import {DxSessionRefreshResult} from "../../../domain/user/dx-session-refresh-result";
import {DxOperationResultType} from "../../../../dx-core/domain/common/dx-operation-result-type";

/**
 * Стратегия обновления сессии при использовании keycloak
 */
@Injectable()
export class DxKeycloakSessionRefreshStrategy implements DxSessionRefreshStrategy {
  private readonly _serverUrl: string;
  private readonly _clientId: string;
  private readonly _realm: string;

  constructor(private _http: DxHttpDispatcher,
              private _configService: DxConfigService,
              private _encryptor: DxEncryptionService) {
    this._serverUrl = this._configService.keycloakServerUrl;
    this._clientId = this._configService.keycloakClientId;
    this._realm = this._configService.keycloakRealm;
  }


  public refreshSession(session: DxUserSession): Observable<DxSessionRefreshResult> {
    const promise = new Promise<DxSessionRefreshResult>((resolve) => {
      const path: string = DxKeycloakUtils.buildAuthRequestUrl(this._serverUrl, this._realm);
      const data = DxKeycloakUtils.prepareTokenRefreshRequestData(this._clientId, session.refreshToken);
      const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

      let result: DxSessionRefreshResult = new DxSessionRefreshResult();
      this._http.post(path, data, {headers: headers, observe: 'response'}).subscribe(response => {
        // получили токен доступа
        const token = response.body[DxKeycloakAuthenticationStrategy.KEYCLOAK_ACCESS_TOKEN];
        let rawData = this._encryptor.decode(token, DxEncryptionStrategyType.KEYCLOAK);
        session.token = token;
        session.tokenExpTime = rawData[DxKeycloakAuthenticationStrategy._KEYCLOAK_TOKEN_EXP_TIME];

        // и токен для обновлени токена
        session.refreshToken = response.body[DxKeycloakAuthenticationStrategy.KEYCLOAK_REFRESH_TOKEN];
        rawData = this._encryptor.decode(session.refreshToken, DxEncryptionStrategyType.KEYCLOAK);
        session.refreshTokenExpTime = rawData[DxKeycloakAuthenticationStrategy._KEYCLOAK_TOKEN_EXP_TIME];

        result.type = DxOperationResultType.SUCCESS;
        resolve(result);

      }, errorResponse => {
        result.type = DxOperationResultType.FAILED;
        result.error = DxHttpDispatcher.handleHttpError(errorResponse);
        resolve(result);
      });
    });
    return fromPromise<DxSessionRefreshResult>(promise);
  }
}
